module.exports = __webpack_public_path__ + "static/fonts/iconfont.5d67502.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.ttf
// module id = Y7Kj
// module chunks = 78